<template>
  <s-sign-call-back-view message-key="TaskList.identification.verifying" />
</template>
<script>
import SSignCallBackView from '@/components/SSignCallBackView'
import { getStorage } from '../utils/storageUtil'
import { globalModule } from '../store/moduleName'
import { LOCAL_STORAGE_KEY } from '../constant/constant'
import signHelper from '../helper/signHelper'
import commonApi from '../api/commonApi'

export default {
  components: {
    SSignCallBackView
  },
  data: () => {
    return {}
  },
  mounted () {
    let eSignOAuthCode = this.$route.query['code']
    let formCode = this.$route.query['formCode']
    let signObj = JSON.parse(getStorage(LOCAL_STORAGE_KEY.SIGN_OBJ))

    if (!this.$route.query['error']) {
      let cb = resp => {
        if ((resp.status === 201 || resp.status === 200)) {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(signObj[signHelper.SUCCESS_MSG_KEY]))
        } else {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(signObj[signHelper.FAIL_MSG_KEY]))
        }
        // this.$router.push({ name: signObj[signHelper.REDIRECT_PATH] })
        this.$router.push(signObj[signHelper.REDIRECT_PATH])
      }
      commonApi.post(signObj[signHelper.SIGN_AND_START_WORKFLOW_URL] + '/' + formCode + '/' + eSignOAuthCode, signObj[signHelper.POST_FORM], cb)
    } else {
      this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(signObj[signHelper.FAIL_MSG_KEY]))
      // this.$router.push({ name: signObj[signHelper.REDIRECT_PATH] })
      this.$router.push(signObj[signHelper.REDIRECT_PATH])
    }
  }
}
</script>
